import styled from 'styled-components';
import { IonTextarea } from '@ionic/react';
import { TextField, Tabs } from '@mui/material';

import colors from '../../../../styles/colors';

// Aligns the tab strip with the header's horizontal padding and separates it from
// the body, matching the Broadcast modal's tabs in the same shell. The white strip
// also helps the modal's light-blue surface read as blue (same as Broadcast).
const StyledTabs = styled(Tabs)`
  width: 100%;
  box-sizing: border-box;
  padding: 0 50px;
  background: ${colors.base.alpha};
  border-bottom: 1px solid ${colors.shades.secondary4};
`;

// White input fills read as cards against the modal's light-blue surface (matches
// the Broadcast modal, whose inputs are likewise white-filled).
const StyledTextField = styled(TextField)`
  margin: 20px 0;
  width: 100%;

  .MuiInputBase-root {
    background-color: ${colors.base.alpha};
  }
`;

const StyledTextarea = styled(IonTextarea)`
  max-height: 110px;
  --padding-start: 14px;
  --background: ${colors.base.alpha};
  border: 1px solid;
  border-radius: 5px;
`;

export {
  StyledTextField,
  StyledTabs,
  StyledTextarea,
};
